import axios from "axios";
import { API_BASE_URL } from "../config";

const getBaseURL = () => {
  if (process.env.NODE_ENV === "development") return "";
  return API_BASE_URL;
};

const http = axios.create({
  baseURL: getBaseURL(),
  headers: { "Content-Type": "application/json", Accept: "application/json" },
  timeout: 60000,
});

type VerifyPublicInput = {
  identificationId: string | number;
  /** Citizen → Hijri `yyyy-MM`; Resident → Gregorian `yyyy-MM-dd` */
  dateOfBirth: string;
};

export type VerifyPublicResult = {
  ok: boolean;
  isCitizen?: boolean;
  nameAr?: string;
  dobHijri?: string | null;
  dobGregorian?: string | null;
  gender?: "male" | "female" | string | null;
  countryName?: string | null;
  regionName?: string | null;
};

export async function verifyPublic(
  input: VerifyPublicInput
): Promise<VerifyPublicResult> {
  let data: any;

try {
  const { data: resData } = await http.post(
    "/api/yaqeen/verify-public",
    { identificationId: input.identificationId, dateOfBirth: input.dateOfBirth },
    {
      validateStatus: (s) => s >= 200 && s < 300,
    }
  );

      data = resData;
    } catch (err: any) {
      const body = err?.response?.data;
      const status = err?.response?.status;

      const message =
        body?.message ||
        body?.detail ||
        body?.title ||
        body?.error ||
        (typeof body === "string" ? body : null) ||
        err?.message ||
        (status === 400 ? "فشل التحقق من بيانات يقين." : "حدث خطأ أثناء التحقق.");

      const e = new Error(message) as Error & { status?: number; body?: any };
      e.status = status;
      e.body = body;
      throw e;
    }
  const s = data?.snapshot ?? {};
  const v = data?.verification ?? {};
  const nameAr =
    s.nameAR ||
    (s as any).nameAr ||
    data?.nameAr ||
    data?.nameAR ||
    [v?.personBasicInfo?.firstName, v?.personBasicInfo?.fatherName, v?.personBasicInfo?.grandFatherName, v?.personBasicInfo?.familyName]
      .filter(Boolean)
      .join(" ")
      .trim();

  const rawGender =
    (s as any).gender ||
    s.gender ||
    (s as any).sexDescAr ||
    (s as any).sexDescEN ||
    v?.personBasicInfo?.sexDescAr ||
    v?.personBasicInfo?.sexDescEN ||
    (v?.personBasicInfo as any)?.gender ||
    data?.gender ||
    null;
  const g = String(rawGender || "")
    .toLowerCase()
    .trim()
    .replace("ذكر", "male")
    .replace("انثى", "female")
    .replace("أنثى", "female");
  const genderNormalized = g === "male" || g === "female" ? g : null;

  const countryName =
      (s as any).nationality ||
      (s as any).countryNameAr ||
      (s as any).nationalityAr ||
      (s as any).countryName ||
      data?.countryNameAr ||
      data?.nationalityAr ||
      v?.personBasicInfo?.nationalityDescAr ||
      v?.personBasicInfo?.nationalityNameAr ||
      (v?.personBasicInfo as any)?.nationalityAr ||
      (v?.personBasicInfo as any)?.countryNameAr ||
      null;

  const regionName =
    (s as any).regionNameAr ||
    (s as any).regionName ||
    s.regionNameAr ||
    (s as any).region ||
    data?.regionNameAr ||
    data?.regionName ||
    (v?.personBasicInfo as any)?.regionNameAr ||
    (v?.personBasicInfo as any)?.regionName ||
    (v?.address as any)?.regionNameAr ||
    (v?.address as any)?.regionName ||
    null;

  const pbi = v?.personBasicInfo ?? {};
  const convertDate = pbi.convertDate ?? {};

  const dobHijri =
    s.dobHijri ||
    (s as any).dobHijri ||
    data?.dobHijri ||
    convertDate.dateString ||
    pbi.birthDateH ||
    pbi.birthDateHijri ||
    null;

  const dobGregorian =
    s.dobGregorian ||
    (s as any).dobGregorian ||
    data?.dobGregorian ||
    pbi.birthDateG ||
    pbi.birthDateGregorian ||
    pbi.birthDate ||
    convertDate.gregorianDate ||
    (convertDate as any).gregorian ||
    null;

  return {
    ok: true,
    isCitizen: !!data?.isCitizen,
    nameAr: nameAr || "",
    dobHijri,
    dobGregorian,
    gender: genderNormalized,
    countryName: countryName ? String(countryName).trim() : null,
    regionName: regionName ? String(regionName).trim() : null,
  };
}
